import axios from 'axios'
import localforage from 'localforage'

const RESOURCE_NAME = '/products'
const PRODUCTS = localforage.getItem('products')

export default {
  getAll (params) {
    let apiParams = new URLSearchParams(window.location.search).toString()
    if (params) {
      apiParams = Object.entries(params).map(([key, val]) => `${key}=${val}`).join('&')
    }
    if (apiParams) {
      return axios.get(`${RESOURCE_NAME}?${apiParams.toString()}`)
    } else {
      return axios.get(`${RESOURCE_NAME}`)
    }
  },

  getAllSync (params) {
    return axios.get(`${RESOURCE_NAME}?per_page=-1`)
  },

  get (id) {
    return axios.get(`${RESOURCE_NAME}/${id}`)
  },

  create (data) {
    return axios.post(RESOURCE_NAME, data)
  },

  update (id, data) {
    return axios.post(`${RESOURCE_NAME}/${id}`, data)
  },

  delete (id) {
    return axios.delete(`${RESOURCE_NAME}/${id}`)
  },

  deleteMedia (id, index) {
    return axios.delete(`${RESOURCE_NAME}/delete-media/${id}`)
  },

  getWarehouses () {
    return axios.get(`/warehouse`)
  },
  getManufacturers () {
    return axios.get(`products/manufacturers`)
  },

  async getSearchData (params) {
    let urlParams = new URLSearchParams(params)
    let products = {
      data: {
        data: [],
        meta: {}
      }
    }
    // let response = PRODUCTS
    await PRODUCTS.then((response) => {
      // let init = new Date().getTime()
      let perPage = urlParams.get('per_page') ? urlParams.get('per_page') : 25
      let page = urlParams.get('page') ? urlParams.get('page') : 1
      let qIn = urlParams.get('q_in') ? urlParams.get('q_in') : 'name'

      page = page - 1
      let start = page * perPage
      let stop = parseInt(start, 10) + parseInt(perPage, 10)
      // SEARCH
      if (urlParams.get('q')) {
        let search = urlParams.get('q').toLowerCase()
        search = search.replace(/\s+/g, ' ')
        let keywords = search.split(' ')
        let emptySearchKey = 0
        let searchField = null
        switch (qIn) {
          case 'name':
            searchField = 'name'
            break
          case 'manufacturer':
            searchField = 'manufacturer'
            break
          case 'internal':
            searchField = 'cod_intern'
            break
          case 'external':
            searchField = 'cod_extern'
            break
          default:
            emptySearchKey = 1
            break
        }
        let scoreName = 0
        let scoreManufacturer = 0
        let okName = 1
        let okManufacturer = 1
        let ok = 1
        let score = 1

        response = response.filter(function (data) {
          score = 0
          // test
          // if (data['name'].includes(search)) {
          //   return data
          // }
          // end test
          if (emptySearchKey) {
            scoreName = 0
            scoreManufacturer = 0
            okName = 1
            okManufacturer = 1
            data.name_search = data.name ? data.name.toLowerCase() : null
            data.manufacturer_search = data.manufacturer ? data.manufacturer.toLowerCase() : null
            for (let i = 0; i < keywords.length; i++) {
              if (data.name_search && !data.name_search.includes(keywords[i])) {
                okName = 0
              }
              if (data.manufacturer_search && !data.manufacturer_search.includes(keywords[i])) {
                okManufacturer = 0
              }
              if (!okManufacturer && !okName) break
            }
            if (okName) {
              scoreName = keywords.length + 1
            }

            if (okManufacturer) {
              scoreManufacturer = keywords.length + 1
            }

            if (data.name_search && data.name_search.includes(search)) {
              scoreName += keywords.length * 2
            }
            if (data.manufacturer_search && data.manufacturer_search.includes(search)) {
              scoreManufacturer += keywords.length * 2
            }

            for (let i = 0; i < keywords.length; i++) {
              if (data.name_search && data.name_search.includes(keywords[i])) {
                scoreName += keywords.length - i
              }
              if (data.manufacturer_search && data.manufacturer_search.includes(keywords[i])) {
                scoreManufacturer += keywords.length - i
              }
            }

            score = scoreName + scoreManufacturer
            if (score > 0) {
              data['score'] = score
              return data
            }
          } else {
            ok = 1
            let dataSearchfield = data[searchField] ? data[searchField].toLowerCase() : null
            for (let i = 0; i < keywords.length; i++) {
              if (dataSearchfield && !dataSearchfield.includes(keywords[i])) {
                ok = 0
                break
              }
            }
            if (ok) {
              score = keywords.length + 1
            }
            if (dataSearchfield && dataSearchfield.includes(search)) {
              score += keywords.length * 2
            }
            // Indobitocing Searrch :(
            // for (let i = 0; i < keywords.length; i++) {
            //   if (data.name && data.name.toLowerCase().includes(keywords[i])) {
            //     score += keywords.length - i
            //   }
            // }

            if (score > 0 && dataSearchfield !== '') {
              data['score'] = score
              return data
            }
          }
        })
      }
      response.sort((a, b) => (a.score > b.score) ? -1 : 1)
      let total = response.length
      products.data.data = response.slice(start, stop)
      products.data.meta = {
        current_page: page + 1,
        from: start,
        last_page: Math.ceil(total / perPage),
        per_page: perPage,
        to: stop,
        total: total
      }
      // let time = (new Date()).getTime() - init
      // console.log(time, 'response ' + urlParams.get('q'))
    })
    return products
  },

  getPriceCategories () {
    return [
      { value: '1', display: 'Minim', name: 'pp_minim', addition: 'aa_minim' },
      { value: '2', display: 'Distributie', name: 'pp_distributie', addition: 'aa_distributie' },
      { value: '3', display: 'Partener', name: 'pp_partener', addition: 'aa_partener' },
      { value: '4', display: 'EnGross fix', name: 'pp_en_gross_fix', addition: 'aa_en_gross_fix' },
      { value: '5', display: 'Amanunt', name: 'pp_amanunt', addition: 'aa_amanunt' }
    ]
  }
}
